import React from 'react';

const CircleRefreshIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g fill="none" fillRule="evenodd">
            <circle cx="20" cy="20" r="20" fill="#fad536" />
            <g stroke="#FFF" strokeWidth="2" transform="translate(10 9)">
                <path d="M0 11C0 5.5 4.5 1 10 1 13.9 1 17.3 3.2 18.9 6.5M20 11C20 16.5 15.5 21 10 21 6.1 21 2.7 18.8 1.1 15.5" />
                <polyline strokeLinecap="square" points="19.8 .7 19 6.6 13 5.8" />
                <polyline strokeLinecap="square" points=".2 21.3 1 15.4 7 16.2" />
            </g>
        </g>
    </svg>
);

export default CircleRefreshIcon;
